import React from 'react';
import { Alert } from '@planne-software/uni';
import { IconInfoCircle } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';

export const RescheduleUnavailableAlert = () => {
  const { i18n } = useTranslate();

  return (
    <Alert
      data-testid='reschedule-unavailable'
      severity='warning'
      canClose={false}
      title={i18n('checkout_confirmed_reschedule_unavailable')}
      startIcon={<IconInfoCircle size={20} aria-hidden />}
      sx={{ marginTop: 0, width: '100%' }}
    />
  );
};

export default RescheduleUnavailableAlert;
